import { useDrop } from 'react-dnd';

import { ItemType } from 'partsOld/enums';
import { IPill } from 'partsOld/types';

import DragAndDropHeaderView from './DragAndDropHeaderView';
import { useDragAndDrop } from '../useDragAndDrop';
import { hiddenCostPillList } from '../../constants';

interface IProps {
  item: string;
  index: number;
  initialPills: IPill[];
  addNewHeader: boolean;
}

const mapHeaders = (element, item) => {
  const costHeader = hiddenCostPillList.find((el) => el.name.includes(item));

  if (costHeader) {
    return element?.columnHeader.includes(item);
  }

  return element?.columnHeader === item;
};

const DragAndDropHeader = ({ item, index, initialPills, addNewHeader }: IProps) => {
  const { addPills } = useDragAndDrop();

  const pill = initialPills?.find((element) => mapHeaders(element, item));

  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemType.PILL,
    drop: (selectedItem: IPill) => addPill(selectedItem),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const addPill = (selectedItem: IPill) => {
    addPills({ ...selectedItem, columnHeader: item, index });
  };

  return (
    <DragAndDropHeaderView
      drop={drop}
      isOver={isOver}
      pill={pill}
      item={item}
      addNewHeader={addNewHeader}
    />
  );
};

export default DragAndDropHeader;
